"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var clickableCustomTooltipStyles = makeStyles_1.default(function (theme) { return ({
    tooltipIconButton: {
        width: '14px',
        height: '14px',
        fontSize: theme.typography.fontXS,
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        margin: '0 0 20px 4px',
        padding: '10px',
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
        },
    },
    tooltipSvg: {
        width: '20px',
        height: '20px',
    },
    tooltipArrow: {
        fontSize: theme.typography.fontXS,
        width: 17,
        '&:before': {
            border: "1px solid " + theme.palette.primary.main,
            backgroundColor: theme.palette.common.white,
            boxSizing: 'border-box',
        },
        '&:after': {
            display: 'none',
        },
    },
    tooltipContainer: {
        position: 'relative',
        borderRadius: 10,
        fontSize: theme.typography.fontXS,
        background: theme.palette.common.white,
        color: theme.palette.common.black,
        border: "1px solid " + theme.palette.primary.main,
        margin: 0,
        padding: '15px 30px 20px 15px',
        boxShadow: '0px 2px 5px rgba(0,0,50,0.2)',
    },
}); }, { name: 'GqlSummary_ClickableCustomTooltip' });
exports.default = clickableCustomTooltipStyles;
